import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import BlogIntro from "./sections/BlogIntro";
import LatestArticlesGrid from "./sections/LatestArticlesGrid";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <BlogIntro />
      <LatestArticlesGrid />
      <Footer />
    </div>;
}